/* eslint-disable */

import React, { forwardRef, useEffect, useState } from "react";
import { getFormValues, reduxForm } from "redux-form";
import { Input } from "../../../UI/InputElement/InputElement";
import { connect } from "react-redux";
import { DateTimeField } from "../../../UI/DateTimeField/DateTimeField";
import {  useParams } from 'react-router-dom/cjs/react-router-dom.min'
import moment from "moment";
import { overRideAvailabilityFormValidator as validate } from "../../../../../utility/validator/validator";
import { tzUTCDateTimeZoneConverterTool_V2 } from "../../../../../utility/TimezoneOperations/timezoneUtility";
import { convertDateFormatV4 } from "../../../../../utility/utility";

let OverrideAvailability = (props) => {
    const { handleSubmit, pristine, reset, submitting, error, frontlineUser } = props;
    const OverrideOrigin  = props.formStates && props.formStates.data;
    
    // params for getting user Id
    const params = useParams();

    console.log("OverrideOrigin", props?.FLShiftDetailBasedAvalibality?.[0]?.slots);
    
    
    const [selectedOption, setSelectedOption] = useState('false'); // Default is 'false' (Slot)
    useEffect(() => {
        if(params?.userId)
        {
            props.getFrontline(params?.userId);
        }
    },[])

    useEffect(() => {
         props.change(`data.type`, 'false')
    },[])
    let optionsSlots;
    const slots = props?.FLShiftDetailBasedAvalibality || [];

    // Map the slots to create an array of objects with id and timeRange
    optionsSlots = slots.map((item, index) => {
        const startTime = moment(item?.is_overwritten ? item?.overwrite_data?.start : item?.start).format("hh:mm A");
        const endTime = moment(item?.is_overwritten ? item?.overwrite_data?.end : item?.end).format("hh:mm A");
        
        const timeRange = `${startTime} - ${endTime}`;
        
        return {
        value: item.id,
        label: timeRange
        };
    });

    console.log("optionsSlots", optionsSlots);
    console.log(props?.FLShiftDetailBasedAvalibality,"responsesss");
    
    


    const handleChange = (event) => {
      setSelectedOption(event.target.value); // Update the selected option based on user's click
    };
    

    const formatDate = (date) => {
        const formattedDate = new Date(date)
        const month = formattedDate.toLocaleString('en-US', { month: 'long' });
        const year = formattedDate.getFullYear();
        return `${month} ${year}`;
    };

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (

        <div style={{ marginLeft: "-20px", cursor: 'pointer' }} className="font-weight-bold h6" onClick={onClick} ref={ref}>
            {formatDate(value)} <i style={{ fontSize: "17px" }} className="fa">&#xf107;</i>
        </div>
    ));

     const handleDateChange = (value) => {
        if(!params?.userId || !value || !frontlineUser?.account_timezone)
        {
            return false
        }
        // get the slots Data
        props.getShiftDetailForSingleFLUser({
            user_id: params?.userId,
            date: tzUTCDateTimeZoneConverterTool_V2(convertDateFormatV4(value),frontlineUser?.account_timezone, 'from'),
            timezone: frontlineUser?.account_timezone
        });
    }


    return (
        <main className="app-content wraper_content user_newQuote add_account_modal add_New_Accont newuser">
            <div className="inspection_content_sec appcontent_Inner">
                <div className="container-fluids">
                    <div className="ticket_form">
                        <h2 className="md_title">
                            Request for change in Availability
                        </h2>
                    </div>
                    <form onSubmit={handleSubmit} className="form_content">
                        <div className="quote_form overrideAvailability_form">
                            <div className="addQuote_form scroll_acc_com">
                                <div className="cst_tab_content">
                                    <div className="row">
                                        <div class="col-md-12">
                                            <div className="mb-2"
                                            style={{
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                display: 'block',  
                                                marginBottom: '5px',
                                              }}
                                            > 
                                            Select Date
                                            </div>
                                            <label>
                                                <Input 
                                                    name="data[start_date]" 
                                                    dateFormat="MM-dd-yyyy" 
                                                    placeholder="Select Date" 
                                                    minDate={new Date()} 
                                                    datePickerType={"react-datepicker"} 
                                                    type="date" 
                                                    className="form-control input-modifier start_date_custom_width" 
                                                    onChange={(value) => handleDateChange(value)} 
                                                    />
                                                <div class="input-group-append cst_group_append" style={{marginTop : '31px'}}>
                                                    <span  class="input-group-text" id="basic-addon2"><i class="fa fa-calendar"></i></span>
                                                </div>
                                            </label>
                                        </div>

                                    </div>
                                    {/* {props?.FLShiftDetailBasedAvalibality?.[0]?.slots?.length > 0} */}
                                    {props?.FLShiftDetailBasedAvalibality?.length > 0 && (

                                    <div className="form-group" style={{ marginTop: '20px' }}>
                                        <Input
                                            type="radio"
                                            labelClass="custom-control-label"
                                            forLable={"customRadio1"}
                                            value={'false'}
                                            label={"Slot"}
                                            className="custom-control-input"
                                            id="customRadio1"
                                            name="data[type]"
                                            checked={selectedOption === 'false'} 
                                            onChange={handleChange} 
                                        />
                                        <Input
                                            type="radio"
                                            labelClass="custom-control-label"
                                            forLable={"customRadio2"}
                                            value={'true'}
                                            label={"Fullday"}
                                            className="custom-control-input"
                                            id="customRadio2"
                                            name="data[type]"
                                            checked={selectedOption === 'true'} 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                    )}
                                    {/* const startTime =  moment(slot.start).format("hh:mm A"); 
                                                                                        const endTime = moment(slot.end).format("hh:mm A"); */}
                                    {/* <div className="form-group" style={{ marginTop: '20px' }}> */}

                                    {OverrideOrigin?.type === "true" ? (
                                        <div className="row">
                                            <div className={selectedOption === "false" ? "col-md-4" : "col-md-6"}>
                                                    <div className="form-group">
                                                        <label htmlFor="data[start_time]" className="form_title" 
                                                            style={{
                                                                fontSize: '16px',
                                                                fontWeight: 'bold',
                                                                color: '#333',
                                                                display: 'block', 
                                                                marginBottom: '5px',
                                                            }}
                                                        >
                                                            Start Time
                                                        </label>
                                                        <DateTimeField 
                                                            timeConstraints={{ minutes: { step: 1 } }} 
                                                            datePickerType='react-datetime' 
                                                            pickerType="timePicker" 
                                                            dataFormat="hh:mm A" 
                                                            className="form-control Input-modifier" 
                                                            id="startTime" 
                                                            name="data[start]"
                                                            />
                                                    </div>
                                                </div>
    
                                                <div className={selectedOption === "false" ? "col-md-4" : "col-md-6"}>
                                                    <div className="form-group">
                                                        <label htmlFor="data[end_time]" className="form_title" 
                                                            style={{
                                                                fontSize: '16px',
                                                                fontWeight: 'bold',
                                                                color: '#333',
                                                                display: 'block', 
                                                                marginBottom: '5px',
                                                            }}
                                                        >
                                                            End Time
                                                        </label>
                                                        <DateTimeField 
                                                            timeConstraints={{ minutes: { step: 1 } }} 
                                                            datePickerType='react-datetime' 
                                                            pickerType="timePicker" 
                                                            dataFormat="hh:mm A" 
                                                            className="form-control Input-modifier" 
                                                            id="endTime" 
                                                            name="data[end]"
                                                            />
                                                    </div>
                                                </div>
                                        </div>

                                    ) : (
                                        <>
                                    {props?.FLShiftDetailBasedAvalibality?.length > 0 && (
                                        <>
                                        {props?.FLShiftDetailBasedAvalibality?.map((item, index) => {
                                           
                                            return(
                                                <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="data[start_time]" className="form_title" 
                                                            style={{
                                                                fontSize: '16px',

                                                                fontWeight: 'bold',
                                                                color: '#333',
                                                                display: 'block', 
                                                                marginBottom: '5px',
                                                            }}
                                                        >
                                                            Availability
                                                        </label>
 
                                                         <Input
                                                            dataTest="assignRoles"
                                                            name={`data.slots[${index}].availability`}
                                                            type="inputSelect"
                                                            options={[optionsSlots[index]]}
                                                            className="days_select_container"
                                                        /> 


                                                            

                                                        {/* <Input 
                                                        type="text" 
                                                        readOnly={true} 
                                                        className="form-control Input-modifier" 
                                                        // placeholder={timeRange} 
                                                        id="availability"
                                                        value={timeRange}
                                                        name={`data.slots[${index}].availability`}
                                                        /> */}
                                                        
                                                        
                                                        
                                                    </div>
                                                </div>    
    
                                                <div className={selectedOption === "false" ? "col-md-4" : "col-md-6"}>
                                                    <div className="form-group">
                                                        <label htmlFor="data[start_time]" className="form_title" 
                                                            style={{
                                                                fontSize: '16px',
                                                                fontWeight: 'bold',
                                                                color: '#333',
                                                                display: 'block', 
                                                                marginBottom: '5px',
                                                            }}
                                                        >
                                                            Start Time
                                                        </label>
                                                        <DateTimeField 
                                                            timeConstraints={{ minutes: { step: 1 } }} 
                                                            datePickerType='react-datetime' 
                                                            pickerType="timePicker" 
                                                            dataFormat="hh:mm A" 
                                                            className="form-control Input-modifier" 
                                                            id="startTime" 
                                                            name={`data.slots[${index}].start`}
                                                            />
                                                    </div>
                                                </div>
    
                                                <div className={selectedOption === "false" ? "col-md-4" : "col-md-6"}>
                                                    <div className="form-group">
                                                        <label htmlFor="data[end_time]" className="form_title" 
                                                            style={{
                                                                fontSize: '16px',
                                                                fontWeight: 'bold',
                                                                color: '#333',
                                                                display: 'block', 
                                                                marginBottom: '5px',
                                                            }}
                                                        >
                                                            End Time
                                                        </label>
                                                        <DateTimeField 
                                                            timeConstraints={{ minutes: { step: 1 } }} 
                                                            datePickerType='react-datetime' 
                                                            pickerType="timePicker" 
                                                            dataFormat="hh:mm A" 
                                                            className="form-control Input-modifier" 
                                                            id="endTime" 
                                                            name={`data.slots[${index}].end`}
                                                            />
                                                    </div>
                                                </div>
                                                </div>
                                            )
                                        }    
                                          
                                        )}
                                            </>
                                    
                                        )}
                                        </>
                                    )}

                                    {/* </div> */}

                                </div>
                                <div className="modal-footer">
                                <button
                                        data-test="cancel_button"
                                        type="button"
                                        className="btn btn-outline-secondary cst_btn"
                                        onClick={() => props.onCancelClicked()}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        data-test="submit_button"
                                        type="submit"
                                        disabled={props.isLoading}
                                        className={
                                            props.isLoading
                                                ? "btn cst_btn btn_danger mr-2 btn-wait"
                                                : "btn cst_btn btn_danger mr-2"
                                        }
                                    >
                                        {props.isLoading ? "" : "Submit"}{" "}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </main>
    );
}

const mapStateToProps = (state) => {
    let initialValues = {}
    const getinitailSlots = (data) => {
        return data?.map(slot => {
            const startTime = moment(slot?.is_overwritten ? slot?.overwrite_data?.start : slot?.start).format("hh:mm A");
            const endTime = moment(slot?.is_overwritten ? slot?.overwrite_data?.end : slot?.end).format("hh:mm A");

            const timeRange = `${startTime} - ${endTime}`;
            return {
                availability: {
                    value: slot.id,
                    label: timeRange
                },
                start: "",
                end: ""
            };
        });
    };

    const isSlotsAvailable = state?.form?.overrideAvailabilityForm?.values?.data?.type === "true";

     initialValues = {
        data: isSlotsAvailable
            ? {
                type: "true", 
                start_date: state  && state?.form?.overrideAvailabilityForm?.values?.data?.start_date || "",
                start: "",
                end: ""
            }
            : {
                type: "false", 
                start_date: state  && state?.form?.overrideAvailabilityForm?.values?.data?.start_date || "",
                slots: state?.TimeTrackerModReducer?.FLShiftDetailBasedAvalibality?.length > 0
                    ? getinitailSlots(state?.TimeTrackerModReducer?.FLShiftDetailBasedAvalibality)
                    : []
            }
    };

    // if(state?.form?.overrideAvailabilityForm?.values?.data)
    // {
    //     initialValues = {
    //         data: isSlotsAvailable
    //             ? {
    //                 type: state  && state?.form?.overrideAvailabilityForm?.values?.data?.type || "", 
    //                 start_date: state  && state?.form?.overrideAvailabilityForm?.values?.data?.start_date || "",
    //                 start: state  && state?.form?.overrideAvailabilityForm?.values?.data?.start || "",
    //                 end: state  && state?.form?.overrideAvailabilityForm?.values?.data?.end || "",
    //             }
    //             : {
    //                 type: state  && state?.form?.overrideAvailabilityForm?.values?.data?.type || "", 
    //                 start_date: state  && state?.form?.overrideAvailabilityForm?.values?.data?.start_date || "",
    //                 slots: state  && state?.form?.overrideAvailabilityForm?.values?.data?.slots || state?.TimeTrackerModReducer?.FLShiftDetailBasedAvalibality?.length > 0
    //                 ? getinitailSlots(state?.TimeTrackerModReducer?.FLShiftDetailBasedAvalibality)
    //                 : []              
    //           }
    //     };
    // }

    
    return {
        initialValues: initialValues,
        formStates: getFormValues('overrideAvailabilityForm')(state)
    };
};


OverrideAvailability = reduxForm({
    form: "overrideAvailabilityForm",
    validate,
    enableReinitialize: true,
})(OverrideAvailability);

OverrideAvailability = connect(mapStateToProps)(OverrideAvailability);

export default OverrideAvailability;